import * as moment from "moment";
import { TreeNode } from "../../ui-kit/ITreeSelect/ITreeSelect";
import { disabledDateFromStartToEnd } from "../../modules/ControlTer/constants";

export const convertDate = (
  timestamp?: string | Date | number,
  format = "DD.MM.YYYY",
) => {
  if (timestamp) {
    return moment(timestamp).format(format);
  }
};

export const getMaxDateOfList = (arrayOfDates) => {
  const newArr = arrayOfDates?.filter((date) => date)?.map((dt) => moment(dt));
  const maxVal = moment.max(newArr);
  return maxVal;
};

export const getRussianMonthName = (monthNumber) => {
  const months = {
    1: "январь",
    2: "февраль",
    3: "март",
    4: "апрель",
    5: "май",
    6: "июнь",
    7: "июль",
    8: "август",
    9: "сентябрь",
    10: "октябрь",
    11: "ноябрь",
    12: "декабрь",
  };
  return months[monthNumber];
};

export const getRussianMonthNumber = (monthName) => {
  const months = {
    январь: 1,
    февраль: 2,
    март: 3,
    апрель: 4,
    май: 5,
    июнь: 6,
    июль: 7,
    август: 8,
    сентябрь: 9,
    октябрь: 10,
    ноябрь: 11,
    декабрь: 12,
  };
  return months[monthName];
};

interface IMakeTreeDataConfig {
  valueField?: string;
  titleField?: string;
  formNameField?: string;
  selectableParents?: boolean;
}

export const makeTreeData = (
  dataToConvert: any,
  config: IMakeTreeDataConfig = {} as IMakeTreeDataConfig,
): TreeNode[] => {
  const {
    valueField = "id",
    titleField = "title",
    formNameField = "formName",
    selectableParents = false,
  } = config;

  function recursive(data) {
    return data?.map((item) => {
      const treeNode: TreeNode = {
        value: item[valueField],
        title: item[titleField] || item[formNameField],
      };

      if (item.children?.length > 0) {
        treeNode.children = recursive(item.children);
        if (!selectableParents) {
          treeNode.selectable = false;
        }
      }

      return treeNode;
    });
  }

  return recursive(dataToConvert);
};

export const makeTreeDataSelectable = (
  dataToConvert: any,
  config: IMakeTreeDataConfig = {} as IMakeTreeDataConfig,
): TreeNode[] => {
  const {
    valueField = "id",
    titleField = "title",
    formNameField = "formName",
    selectableParents = true,
  } = config;

  function recursive(data) {
    return data?.map((item) => {
      const treeNode: TreeNode = {
        value: item[valueField],
        title: item[titleField] || item[formNameField],
      };

      if (item.children?.length > 0) {
        treeNode.children = recursive(item.children);
        if (!selectableParents) {
          treeNode.selectable = true;
        }
      }

      return treeNode;
    });
  }

  return recursive(dataToConvert);
};

export const getDisabledData = (d) => {
  const year = moment().year();
  return disabledDateFromStartToEnd(d, "1703", String(+year + 100));
};
export const disabledNextData = (current) =>
  moment() <= current && +moment(current).format("YYYY") >= 1703;

export const checkDateValue = (value = "") =>
  moment(value).isValid() && !getDisabledData(moment(value));

export const parserDateString = (str = "", format = "") => {
  const regTest =
    /^\d{1,2}(\.|-|\\|\/|\s){1,}\d{1,2}(\.|-|\\|\/|\s){1,}\d{2,4}?/;
  if (
    str &&
    typeof str === "string" &&
    moment(str).isValid() &&
    !regTest.test(str)
  ) {
    return format
      ? moment(str).format(format)
      : moment(str).startOf("day").toISOString();
  } else if (str && typeof str === "string" && !regTest?.test(str)) {
    const months = [
      "янв",
      "фев",
      "мар",
      "апр",
      "мая",
      "июн",
      "июл",
      "авг",
      "сен",
      "окт",
      "ноя",
      "дек",
    ];
    const [day, mon, year] = str.replace(/\s{1,}/g, " ").split(" ");
    const date = moment();
    const currentIndexMonth =
      typeof mon === "string" && mon?.substring(0, 3)
        ? months.indexOf(mon?.substring(0, 3).toLowerCase()) > -1
          ? months.indexOf(mon?.substring(0, 3).toLowerCase())
          : -1
        : -1;

    if (typeof +year === "number") {
      date.set("year", +year);
    }
    if (currentIndexMonth > -1) {
      date.set("month", currentIndexMonth);
    }
    if (typeof +day === "number") {
      date.set("date", +day);
    }

    return date.isValid() && day && mon && year && currentIndexMonth > -1
      ? format
        ? date.startOf("day").format(format)
        : date.startOf("day").toISOString()
      : str;
  } else if (str && typeof str === "string" && regTest?.test(str)) {
    const [day, month, year] = str
      .replace(/(,|\.|-|\\|\/|\s){1,}/g, " ")
      .split(" ");
    const date = moment();
    if (year) {
      date.set("year", year?.length === 2 ? +("20" + year) : +year);
    }
    if (month) {
      date.set("month", +month - 1);
    }
    if (day) {
      date.set("date", +day);
    }
    return date.isValid() && day && month && year
      ? format
        ? date.startOf("day").format(format)
        : date.startOf("day").toISOString()
      : str;
  }
  return str;
};

export const timeToLocal = (value: string) => {
  const dt = moment(new Date());
  const m = moment.utc(dt);
  const time = value.split(":");
  m.set({ h: time[0], m: time[1] });
  return m.local().format("HH:mm");
};
